import { IAppContext } from 'App/AppContext';
import User from 'models/user';
import Group from 'models/group';
import { newGuid } from 'utils/guid';
import { Role } from 'models/auth/role';

export class AudienceLine {
  audienceId: number;

  audienceLineId: number;

  userId?: string;

  groupId?: string;

  roleId?: string;

  id: string; //internal Id

  constructor() {
    this.audienceId = 0;
    this.audienceLineId = 0;
    this.id = newGuid();
  }

  hasMember(): boolean {
    return this.userId !== undefined || this.roleId !== undefined || this.groupId !== undefined;
  }

  getMember(appContext: IAppContext): User | Role | Group | undefined {
    if (this.userId) return appContext.globalDataCache.users.get(this.userId);
    if (this.groupId) return appContext.globalDataCache.groups.get(this.groupId);
    if (this.roleId) return appContext.globalDataCache.roles.get(this.roleId);

    return undefined;
  }

  setMember(item: User | Role | Group | undefined) {
    if (item instanceof User) {
      this.userId = item.id;
      this.groupId = undefined;
      this.roleId = undefined;
    } else if (item instanceof Group) {
      this.groupId = item.id;
      this.userId = undefined;
      this.roleId = undefined;
    } else if (item instanceof Role) {
      this.roleId = item.roleId;
      this.userId = undefined;
      this.groupId = undefined;
    } else {
      this.userId = undefined;
      this.groupId = undefined;
      this.roleId = undefined;
    }
  }

  clone(): AudienceLine {
    const output = new AudienceLine();
    output.id = this.id;
    output.audienceId = this.audienceId;
    output.audienceLineId = this.audienceLineId;
    output.userId = this.userId;
    output.groupId = this.groupId;
    output.roleId = this.roleId;

    return output;
  }

  isEqual(item: AudienceLine): boolean {
    if (item.audienceId !== this.audienceId) return false;
    if (item.audienceLineId !== this.audienceLineId) return false;
    if (item.userId !== this.userId) return false;
    if (item.groupId !== this.groupId) return false;
    if (item.roleId !== this.roleId) return false;

    return true;
  }
}
